// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const AssistantIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M20.49 14.53q.38-.53.31-1.16-.08-.64-.6-1.05l-2.71-2.05q-.2-.16-.2-.4l.2-3.43q.03-.52-.29-.99c-.5-.7-1.47-.86-2.16-.36L12.2 7.07q-.21.14-.45.05l-3.2-1.2h-.03q-.46-.14-.94-.03c-.83.25-1.32 1.12-1.09 1.95l.97 3.29q.05.24-.1.45L5.2 14.27q-.35.43-.35.96c-.02.85.67 1.56 1.53 1.57l3.44.06q.24 0 .38.2l1.86 2.85q.31.47.79.62.26.1.52.1.35 0 .67-.16.59-.29.8-.9L16 16.32q.1-.24.34-.31l3.33-.93q.52-.16.82-.55"
        opacity=".5"
      />
      <path d="M11.56 4.58c.44 0 .8-.36.8-.8V2.3c0-.45-.36-.81-.8-.81s-.81.36-.81.8v1.47c0 .45.36.81.8.81m8.73 4.95q.12 0 .24-.04l.97-.3c.43-.14.66-.6.53-1.02-.14-.43-.6-.66-1.02-.53l-.97.32c-.43.13-.66.59-.52 1.01.1.35.42.56.77.56m-16.21.93H2.75c-.44 0-.8.36-.8.8s.36.81.8.81h1.32c.44 0 .8-.36.8-.8s-.36-.81-.8-.81m5.3 8.62c-.42-.14-.88.1-1.02.52L8 20.62q-.04.13-.04.25c0 .34.21.66.55.77q.13.04.25.04c.34 0 .66-.21.77-.55l.34-1.04q.04-.12.04-.25c0-.34-.21-.66-.55-.77m10.01-.5c-.3-.33-.82-.34-1.14-.04-.33.3-.34.81-.04 1.14l2.4 2.57q.25.26.59.26.31 0 .55-.22c.33-.3.34-.81.04-1.14z" />
    </g>
  </SvgIcon>
);

export default AssistantIcon;
